<script>
  import { createEventDispatcher } from "svelte";

  export let label = "The label";
  export let dark = false;

  const dispatch = createEventDispatcher();

  function handleClick(event) {
    dispatch("click", event);
  }
</script>

<button class="button" class:button--dark={dark} on:click={handleClick}>
  {label}
</button>

<style lang="scss">
  @import "./assets/styles/variables";
  @import "./assets/styles/animations";

  $text-color-light: black;
  $text-color-dark: white;
  $border-color-light: white;
  $border-color-dark: $color-orange-light;

  .button {
    background-color: transparent;
    border: 2px solid $border-color-light;
    color: $text-color-light;
    font-family: "Roboto Condensed", sans-serif;
    font-size: 18px;
    font-style: italic;
    font-weight: 600;
    padding: 0.5rem 2rem;
    position: relative;
    text-transform: uppercase;
    z-index: 1;

    &:hover {
      animation: flicker 3s infinite step-end;
      box-shadow: 0 0 16px $border-color-light;
      cursor: pointer;
    }

    &--dark {
      border: 2px solid $border-color-dark;
      color: $text-color-dark;

      &:hover {
        animation: flicker 3s infinite step-end;
        box-shadow: 0 0 16px $border-color-dark;
        cursor: pointer;
      }
    }
  }
</style>
